import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

import { ErpSyncValidationPage } from '@pages/erp-sync-validation';

export const Route = createFileRoute('/$locale/_authenticated/erp-sync/readiness')({
  validateSearch: z.object({
    contract: z.string().optional(),
  }),
  component: ErpSyncReadinessRoute,
});

function ErpSyncReadinessRoute() {
  const { locale } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate();

  return (
    <ErpSyncValidationPage
      initialContractKey={search.contract}
      onOpenMapping={(contractKey) => {
        void navigate({
          to: '/$locale/erp-sync/mapping',
          params: { locale },
          search: { contract: contractKey },
        });
      }}
    />
  );
}
